import React, { useContext, useEffect, useState } from "react";
import "./subsrciptioPlan.css";
import { SubsrciptionPlanContext } from "../SubsrciptionPlanView";
import { Container, Dropdown } from "react-bootstrap";
import DataTable from "../../../../components/TableComponent/DataTable";
import SearchData from "../../../../components/SearchComponent/SearchData";
import ContentData from "../../../../constants/contentFile.json";
import AddOffer from "../../../../assets/images/addOffer.svg";
import SortIcon from "../../../../assets/images/sorting.svg";
import PluseIcon from "../../../../assets/images/pluse.svg";
import Loader from "../../../../components/Loader/Loader";
import FilterIcon from "../../../../assets/images/icons/filter-icon.svg";
import DropUpIcon from "../../../../assets/images/icons/dropup-icon.svg";
import DropDownIcon from "../../../../assets/images/icons/dropdown-icon.svg";
import BulkRole from "../../../../assets/images/bulkroles.svg";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import RoleSelectPopup from "../../../../components/PopupRoleList/RoleListPopup";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";

import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const SubsrciptionPlan = () => {
  const {
    getPlanList,
    planList,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    setStatus,
    selectedRoleId,
    selectedStatusId,
    setSelectedStatusId,
    planToAddPlan,
    showDropdown,
    handleSelect,
    handleToggle,
    setRoleSelectData,
    roleSelectData,
    roleList,
    handleRoleChange,
    roleCategotyValidate,
    successAlertShow,
    successAlertMessage,
    statusValue,
    bulkRoleAssignApi,
    setSuccessAlertShow,
    selectedUsers,
    status,
    setSelectedUsers,
    checkBoxDisable,
    onClickFilterButton,
    sorting,
    onClickSortButton,
    handleSortSelect,
    handleSortToggle,
    showCountDropdown,
    selectedSortId,
    setSelectedSortId,
    setSorting,
    permissionAccess,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    buttonText,
    goToLogin,
  } = useContext(SubsrciptionPlanContext);

  const [isStatusExpanded, setIsStatusExpanded] = useState(false);
  const [isSortExpanded, setIsSortExpanded] = useState(false);
  const handleSelectedAll = (isChecked) => {
    if (isChecked) {
      // Select all user IDs
      setSelectedUsers(planList.map((user) => user.id));
    } else {
      // Clear all selections
      setSelectedUsers([]);
    }
  };
  const statuses = [
    { id: "A", name: "Active" },
    { id: "I", name: "Inactive" },
  ];

  const sortData = [
    { id: "0-5", name: "0-5" },
    { id: "6-10", name: "6-10" },
    { id: "11-15", name: "11-15" },
    { id: "16-20", name: "16-20" },
  ];

  const header = [
    // {
    //   title: (
    //     <CheckBox
    //       id="select-all"
    //       check={
    //         selectedUsers.length === planList.length && planList.length > 0
    //       }
    //       onChange={(e) => {
    //         handleSelectedAll(e.target.checked);
    //       }}
    //       additionStyle="allCheckBoxSelect"
    //     />
    //   ),
    //   prop: "bulkData",
    // },
    { title: "NAME", prop: "name" },
    { title: "Price", prop: "price" },
    { title: "Billing", prop: "billingCycle" },
    { title: "STATUS", prop: "status" },
    { title: "TRIAL PERIOD", prop: "trialPeriod" },
    { title: "SUBSCRIBER count", prop: "subCount" },
    { title: " ", prop: "action" },
  ];

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      getPlanList(pageCount, status, sorting);
    }, 900);
    return () => clearTimeout(timeoutID);
  }, [pageCount, status, sorting]);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="boldBreadCrums">
          {ContentData.planManagement.subscriptionHead}
        </span>
      </div>
      {spinnerStatus && <Loader />}

      <Container>
        <div className="subscriptionpage">
          <div className="pageTittles">
            {ContentData.planManagement.subscriptionHead}
          </div>
          <div className="plusRefreshDtat">
            <Dropdown
              autoClose="outside"
              show={showDropdown}
              onToggle={handleToggle}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
              >
                <div className="adminFilterIcon">
                  <img src={FilterIcon} alt="filter" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="admin-dropdown-menu "
                style={{
                  backgroundColor: "#F7F8FA",
                  width: "258px",
                  marginTop: "34px",
                }}
              >
                <Dropdown.Item className="dropdown-filter-clear">
                  <span className="filter-text">
                    {ContentData.adminPage.filter}
                  </span>
                  <span
                    className="clear-all"
                    onClick={() => {
                      handleSelect();

                      setStatus("");

                      setSelectedStatusId("");
                    }}
                  >
                    {ContentData.adminPage.clearAll}
                  </span>
                </Dropdown.Item>

                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isStatusExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsStatusExpanded(!isStatusExpanded);
                  }}
                  style={{
                    borderBottom: "0",
                  }}
                >
                  Status
                  <img
                    src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>

                {/* Status items */}
                {isStatusExpanded &&
                  statuses.map((status) => (
                    <Dropdown.Item
                      className={`dropdownItem status-item ${
                        selectedStatusId === status.id ? "selected" : ""
                      }`}
                      key={status.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        const newStatusId =
                          selectedStatusId === status.id ? "" : status.id;
                        setSelectedStatusId(newStatusId);
                      }}
                      style={{
                        paddingLeft: "20px",
                        height: "48px",
                      }}
                    >
                      {status.name}
                    </Dropdown.Item>
                  ))}

                {/* Apply Button */}
                <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                  <ThemeButton
                    value={"Apply"}
                    className={""}
                    onClick={() => {
                      onClickFilterButton(selectedStatusId);
                    }}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown
              autoClose="outside"
              show={showCountDropdown}
              onToggle={handleSortToggle}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
              >
                <div className="adminFilterIcon">
                  <img src={SortIcon} alt="filter" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="admin-dropdown-menu "
                style={{
                  backgroundColor: "#F7F8FA",
                  width: "258px",
                  marginTop: "34px",
                }}
              >
                <Dropdown.Item className="dropdown-filter-clear">
                  <span className="filter-text">Sort</span>
                  <span
                    className="clear-all"
                    onClick={() => {
                      handleSortSelect();

                      setSorting("");

                      setSelectedSortId("");
                    }}
                  >
                    {ContentData.adminPage.clearAll}
                  </span>
                </Dropdown.Item>

                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isSortExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsSortExpanded(!isSortExpanded);
                  }}
                  style={{
                    borderBottom: "0",
                  }}
                >
                  Subscriber count
                  <img
                    src={isSortExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>

                {/* Status items */}
                {isSortExpanded &&
                  sortData.map((sort) => (
                    <Dropdown.Item
                      className={`dropdownItem status-item ${
                        selectedSortId === sort.id ? "selected" : ""
                      }`}
                      key={sort.id}
                      onClick={(e) => {
                        // handleSelect();
                        e.stopPropagation();
                        const newStatusId =
                          selectedSortId === sort.id ? "" : sort.id;
                        setSelectedSortId(newStatusId);
                      }}
                      style={{
                        paddingLeft: "20px",
                        height: "48px",
                      }}
                    >
                      {sort.name}
                    </Dropdown.Item>
                  ))}

                {/* Apply Button */}
                <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                  <ThemeButton
                    value={"Apply"}
                    className={""}
                    onClick={() => {
                      onClickSortButton(selectedSortId);
                    }}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* <div
              className={`bulkUploadData ${!checkBoxDisable ? "disabled" : ""}`}
              onClick={() => checkBoxDisable && setRoleSelectData(true)}
            >
              <img src={AddOffer} alt="add" />
              <span>{ContentData.planManagement.addOffers}</span>
            </div> */}
            <div
              className={`addAdmin  addDataAdmin ${
                permissionAccess?.add ? "" : "disabledMainButton"
              }`}
              onClick={() => planToAddPlan()}
            >
              <img src={PluseIcon} alt="add" />
              <span>{ContentData.planManagement.addPlanHead}</span>
            </div>
          </div>
        </div>
        <div className="basicContainer roleListTable">
          <DataTable
            tableData={planList}
            header={header}
            onPageChange={(e) => onPageChange(e)}
            isPagination={true}
            currentPage={pageCount}
            pageCount={totalPage}
          />
        </div>
      </Container>

      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getPlanList(pageCount, status, sorting);
          }
        }}
      />
      {/* <SuccessPopupAlert
      show={successAlertShow}
      alertMessage={successAlertMessage}
    /> */}
    </div>
  );
};

export default SubsrciptionPlan;
